'use client'

import React from 'react'
import { Stack, Title, Text, ScrollArea, Group } from '@mantine/core'
import { HealthCondition, HealthMedication, HealthAllergy, HealthProcedure } from '@/lib/store/api/chatApi'
import DrawerOrModalContent from '@/components/shared/DrawerOrModalContent'

interface HealthDetailsAdaptiveModalProps {
    opened: boolean
    onClose: () => void
    title: string
    items: HealthCondition[] | HealthMedication[] | HealthAllergy[] | HealthProcedure[]
    type: 'conditions' | 'medications' | 'allergies' | 'procedures'
}

const HealthDetailsAdaptiveModal: React.FC<HealthDetailsAdaptiveModalProps> = ({
    opened,
    onClose,
    title,
    items,
    type,
}) => {
    const renderItem = (item: HealthCondition | HealthMedication | HealthAllergy | HealthProcedure, index: number) => {
        if (type === 'medications') {
            const med = item as HealthMedication
            return (
                <Stack
                    key={index}
                    gap="xs"
                    p="md"
                    style={{
                        backgroundColor: '#FAF7F5',
                        borderRadius: '8px',
                    }}
                >
                    <Text fw={500} size="sm" c="gray.9">
                        {med.name}
                    </Text>
                    <Group gap="md">
                        <Text size="xs" c="gray.6">
                            <strong>Dose:</strong> {med.dose_value}
                        </Text>
                    </Group>
                </Stack>
            )
        } else {
            // For conditions, allergies, and procedures - they all just have name and id
            const simpleItem = item as HealthCondition | HealthAllergy | HealthProcedure
            return (
                <Stack
                    key={index}
                    gap="xs"
                    p="md"
                    style={{
                        backgroundColor: '#FAF7F5',
                        borderRadius: '8px',
                    }}
                >
                    <Text fw={500} size="sm" c="gray.9">
                        {simpleItem.name}
                    </Text>
                </Stack>
            )
        }
    }

    const content = (
        <>
            <ScrollArea.Autosize mah={400}>
                <Stack gap="sm">{items.map((item, index) => renderItem(item, index))}</Stack>
            </ScrollArea.Autosize>
        </>
    )

    return (
        <DrawerOrModalContent
            content={content}
            showContent={opened}
            setShowContent={(show) => !show && onClose()}
            onClose={onClose}
            title={
                <Title order={3} c="gray.9">
                    All {title}
                </Title>
            }
        />
    )
}

export default HealthDetailsAdaptiveModal
